import type { GPUInstanceType } from "types/InstanceTypes";
import { getPrimaryInstanceCloudCredId } from "utils/cloudCreds";

export const hasInstanceSelectionChanged = (
  currentInstance: GPUInstanceType | null,
  nextInstance: GPUInstanceType | null,
) => {
  if (!currentInstance || !nextInstance) {
    return currentInstance !== nextInstance;
  }

  return (
    currentInstance.type !== nextInstance.type ||
    getPrimaryInstanceCloudCredId(currentInstance) !==
      getPrimaryInstanceCloudCredId(nextInstance)
  );
};
